import {AManagerApi} from "@/classes/app/api/manager/a-manager-api";

export default class OwnerPaymentCard extends AManagerApi {
    protected _url: string = '/owner/payment/card';
}
